angular.module('ikeweb.folders').factory('folderFactory', ['ObjectFactory',
    function(ObjectFactory) {
        return new ObjectFactory(['name', 'parentId']);
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/folders/folder.factory.js
// module id = 454
// module chunks = 0